export default "__VITE_ASSET__LbxZsg5K__"